'use client';

import Decimal from 'decimal.js';
import { usePathname, useSearchParams } from 'next/navigation';
import { useEffect, useRef } from 'react';
import { useOrderFormStore } from '@/lib/store/order-form-store';
import { EMarketAction } from '@/lib/types/market-action';
import { EMarketIntent } from '@/lib/types/market-intent';
import { EMarketOrderType } from '@/lib/types/market-order-type';

export function SellParamsInitializer() {
  const searchParams = useSearchParams();
  const pathname = usePathname();
  const appliedRef = useRef(false);

  const setAction = useOrderFormStore.use.setAction();
  const setIntent = useOrderFormStore.use.setIntent();
  const setOrderType = useOrderFormStore.use.setOrderType();
  const setSharesCount = useOrderFormStore.use.setSharesCount();
  const setLimitPrice = useOrderFormStore.use.setLimitPrice();
  const setAmountUsd = useOrderFormStore.use.setAmountUsd();
  const setSelectedOutcomeId = useOrderFormStore.use.setSelectedOutcomeId();
  const triggerLightningAnimation = useOrderFormStore.use.triggerLightningAnimation();

  useEffect(() => {
    if (appliedRef.current) return;
    if (searchParams.get('action') !== 'SELL') return;
    appliedRef.current = true;

    const intent = searchParams.get('intent') === 'NO' ? EMarketIntent.NO : EMarketIntent.YES;
    const shares = parseFloat(searchParams.get('shares') ?? '0') || 0;
    const outcomeId = searchParams.get('outcomeId');

    setAction(EMarketAction.SELL);
    setIntent(intent);
    setOrderType(EMarketOrderType.MARKET);
    setSharesCount(new Decimal(shares));
    setLimitPrice(new Decimal(0));
    setAmountUsd(new Decimal(0));
    if (outcomeId) setSelectedOutcomeId(outcomeId);
    triggerLightningAnimation();

    // Clean params from URL without triggering navigation
    const params = new URLSearchParams(searchParams.toString());
    params.delete('action');
    params.delete('intent');
    params.delete('shares');
    params.delete('outcomeId');
    const newUrl = params.size > 0 ? `${pathname}?${params.toString()}` : pathname;
    window.history.replaceState(null, '', newUrl);
  }, [
    searchParams,
    pathname,
    setAction,
    setIntent,
    setOrderType,
    setSharesCount,
    setLimitPrice,
    setAmountUsd,
    setSelectedOutcomeId,
    triggerLightningAnimation,
  ]);

  return null;
}
